module.exports = __webpack_public_path__ + "img/09_DSC7911-min.170105f3.jpg";